<template>
  <v-snackbar :timeout="-1" v-model="snackbar" class="notification">
    <div class="action">
      {{
        $t(
          "This is an example of a message that is commonly used for important information to visitors or users. Please click the button beside to close this message."
        )
      }}
    </div>
    <v-btn color="secondary" class="button" @click="snackbar = false">
      <span v-t="'Accept'" />
    </v-btn>
  </v-snackbar>
</template>

<style lang="scss" scoped>
@import "./notification-style.scss";
</style>

<script>
export default {
  data() {
    return {
      snackbar: true,
    };
  },
};
</script>
